//绘制(三瓦窑的核心区域)
var sanwayao1Km = [
  [104.045498,30.569755], // 起点
  [104.046393,30.575147], // 中间点
  [104.046393,30.580308], // 中间点
  [104.046304,30.585007], // 中间点
  [104.046911,30.588174], // 中间点
  [104.054349,30.588402], // 中间点
  [104.055593,30.588424], // 中间点
  [104.056255,30.588698], // 中间点
  [104.077052,30.58874], // 中间点
  [104.077059,30.586898], // 中间点
  [104.07788,30.583822], // 中间点
  [104.07788,30.583822], // 中间点
  [104.078356,30.581931], // 中间点
  [104.077827,30.579447], // 中间点
  [104.077827,30.579447], // 中间点
  [104.076794,30.577783], // 中间点
  [104.072689,30.573255], // 中间点
  [104.072556,30.571559], // 中间点
  [104.072556,30.571559], // 中间点
  [104.073562,30.569849], // 中间点
  [104.076288,30.568892], // 中间点
  [104.076404,30.568741], // 中间点
  [104.078435,30.567524], // 中间点
  [104.078798,30.566243], // 中间点
  [104.061935,30.565588], // 中间点
  [104.045498,30.569755] // 终点
];

// 绘制(三瓦窑的重点区域)
var sanwayao3Km  = [
  [104.034303,30.593247], // 起点
  [104.042483,30.599516], // 中间点
  [104.046781,30.598493], // 中间点
  [104.07943,30.597627], // 中间点
  [104.096562,30.594679], // 中间点
  [104.095714,30.593239], // 中间点
  [104.094902,30.591898], // 中间点
  [104.092476,30.585652], // 中间点
  [104.092566,30.58063], // 中间点
  [104.091833,30.576551], // 中间点
  [104.092284,30.571209], // 中间点
  [104.091807,30.56743], // 中间点
  [104.091484,30.564933], // 中间点
  [104.09084,30.561465], // 中间点
  [104.088987,30.559315], // 中间点
  [104.08939,30.555777], // 中间点
  [104.087662,30.551627], // 中间点
  [104.088281,30.549144], // 中间点
  [104.080941,30.545819], // 中间点
  [104.077652,30.547789], // 中间点
  [104.07577,30.547707], // 中间点
  [104.073315,30.546866], // 中间点
  [104.021215,30.546599], // 中间点
  [104.019048,30.552707], // 中间点
  [104.017748,30.553148], // 中间点
  [104.024393,30.563803], // 中间点
  [104.029358,30.574231], // 中间点
  [104.034073,30.58747], // 中间点
  [104.034303,30.593247] // 终点
];

// 绘制(沙河铺的核心区域)
var shahepu1Km = [
  [104.099547,30.626556], // 起点
  [104.104974,30.623178], // 中间点
  [104.107453,30.621552], // 中间点
  [104.10815,30.620941], // 中间点
  [104.112185,30.62068], // 中间点
  [104.115267,30.619654], // 中间点
  [104.11909,30.619677], // 中间点
  [104.121319,30.621395], // 中间点
  [104.124093,30.621845], // 中间点
  [104.129198,30.61827], // 中间点
  [104.131382,30.617775], // 中间点
  [104.132911,30.622137], // 中间点
  [104.13459,30.625899], // 中间点
  [104.138362,30.633647], // 中间点
  [104.139524,30.636805], // 中间点
  [104.134101,30.636869], // 中间点
  [104.127555,30.636273], // 中间点
  [104.125414,30.636378], // 中间点
  [104.117768,30.639694], // 中间点
  [104.110365,30.643191], // 中间点
  [104.107106,30.638409], // 中间点
  [104.099547,30.626556], // 终点
];

// 绘制(沙河铺的重点区域)
var shahepu3Km = [
  [104.077924,30.598013], // 起点
  [104.077028,30.620163], // 中间点
  [104.076208,30.633687], // 中间点
  [104.089151,30.639973], // 中间点
  [104.090564,30.64081], // 中间点
  [104.09603,30.649849], // 中间点
  [104.10063,30.657338], // 中间点
  [104.114132,30.651092], // 中间点
  [104.115308,30.650841], // 中间点
  [104.123297,30.650662], // 中间点
  [104.12442,30.650265], // 中间点
  [104.127885,30.647963], // 中间点
  [104.131619,30.647237], // 中间点
  [104.13691,30.648117], // 中间点
  [104.142508,30.649447], // 中间点
  [104.146912,30.649755], // 中间点
  [104.149186,30.650094], // 中间点
  [104.155057,30.648631], // 中间点
  [104.157599,30.6486], // 中间点
  [104.146245,30.622831], // 中间点
  [104.144954,30.617161], // 中间点
  [104.136205,30.605152], // 中间点
  [104.122274,30.597545], // 中间点
  [104.096092,30.594603], // 中间点
  [104.080338,30.597878], // 中间点
  [104.077924,30.598013] // 终点
];

// 绘制(大石西路和君平街的核心区域)
var dashi1Km = [
  [104.013321,30.636126], // 起点
  [104.017157,30.637744], // 中间点
  [104.024367,30.642971], // 中间点
  [104.031568,30.635793], // 中间点
  [104.03766,30.640323], // 中间点
  [104.045785,30.643694], // 中间点
  [104.047109,30.644101], // 中间点
  [104.049718,30.644426], // 中间点
  [104.055382,30.647045], // 中间点
  [104.06071,30.654136], // 中间点
  [104.060618,30.658156], // 中间点
  [104.05852,30.658314], // 中间点
  [104.055611,30.660698], // 中间点
  [104.053046,30.660757], // 中间点
  [104.051739,30.660931], // 中间点
  [104.048561,30.662099], // 中间点
  [104.040621,30.666101], // 中间点
  [104.040788,30.659016], // 中间点
  [104.034409,30.662479], // 中间点
  [104.033639,30.662595], // 中间点
  [104.031457,30.662591], // 中间点
  [104.029015,30.662519], // 中间点
  [104.025738,30.662309], // 中间点
  [104.023631,30.662255], // 中间点
  [104.021659,30.662387], // 中间点
  [104.018774,30.662311], // 中间点
  [104.015838,30.662588], // 中间点
  [104.012344,30.664596], // 中间点
  [104.011547,30.664792], // 中间点
  [104.010255,30.664805], // 中间点
  [104.008096,30.66512], // 中间点
  [104.011651,30.664796], // 中间点
  [104.010043,30.664792], // 中间点
  [104.00806,30.665134], // 中间点
  [104.007774,30.661291], // 中间点
  [104.008004,30.660035], // 中间点
  [104.008445,30.652], // 中间点
  [104.009191,30.64485], // 中间点
  [104.009227,30.643875], // 中间点
  [104.013321,30.636126] // 终点
];

// 绘制(大石西路和君平街的重点区域)
var dashi3Km = [
  [103.987674,30.668182], // 中间点瑞联路
  [103.9913,30.668151], // 中间点
  [103.993992,30.667786], // 中间点
  [103.996549,30.667407], // 中间点
  [103.997821,30.666666], // 中间点
  [104.000237,30.665576], // 中间点
  [104.003323,30.665631], // 中间点
  [104.005415,30.665644], // 中间点
  [104.00806,30.665134], // 中间点
  [104.010043,30.664792], // 中间点
  [104.011651,30.664796], // 中间点
  [104.008096,30.66512], // 中间点
  [104.010255,30.664805], // 中间点
  [104.011547,30.664792], // 中间点
  [104.012344,30.664596], // 中间点
  [104.015838,30.662588], // 中间点
  [104.018774,30.662311], // 中间点
  [104.021659,30.662387], // 中间点
  [104.021457,30.670235], // 中间点
  [104.021457,30.672911], // 中间点
  [104.022606,30.67508], // 中间点
  [104.025437,30.67769], // 中间点
  [104.032034,30.683416], // 中间点
  [104.04009,30.690297], // 中间点
  [104.044152,30.693395], // 中间点
  [104.046452,30.694132], // 中间点
  [104.049804,30.694412], // 中间点
  [104.050683,30.692494], // 中间点
  [104.051305,30.688053], // 中间点
  [104.053594,30.68017], // 中间点
  [104.056845,30.678415], // 中间点
  [104.057574,30.677467], // 中间点
  [104.06804,30.672527], // 中间点
  [104.065506,30.669069], // 中间点
  [104.065685,30.662412], // 中间点
  [104.064221,30.659996], // 中间点
  [104.064307,30.656391], // 中间点
  [104.065838,30.656433], // 中间点
  [104.066514,30.633452], // 中间点
  [104.054938,30.633237], // 中间点
  [104.04425,30.638296], // 中间点
  [104.041484,30.641263], // 中间点
  [104.041326,30.641854], // 中间点
  [104.038004,30.640499], // 中间点
  [104.031567,30.635807], // 中间点
  [104.027833,30.633674], // 中间点
  [104.025732,30.629414], // 中间点
  [104.021385,30.625252], // 中间点
  [104.014051,30.617333], // 中间点
  [104.002002,30.625783], // 中间点
  [104.000714,30.626728], // 中间点
  [103.993478,30.637824], // 中间点
  [103.986549,30.647202], // 中间点
  [103.984149,30.651169], // 中间点
  [103.983897,30.653034], // 中间点
  [103.983888,30.654018], // 中间点
  [103.984744,30.659713], // 中间点
  [103.987895,30.668143] // 终点
];

// 绘制(十里店的核心区域)
var shili1Km = [
  [104.126428,30.680765], // 起点
  [104.132002,30.676503], // 中间点
  [104.12938,30.67286], // 中间点
  [104.129044,30.671646], // 中间点
  [104.129178,30.670634], // 中间点
  [104.129951,30.669102], // 中间点
  [104.126673,30.667363], // 中间点
  [104.131422,30.660106], // 中间点
  [104.132115,30.660478], // 中间点
  [104.133789,30.661844], // 中间点
  [104.134659,30.661358], // 中间点
  [104.135601,30.66045], // 中间点
  [104.136023,30.660758], // 中间点
  [104.136803,30.660981], // 中间点
  [104.139823,30.660632], // 中间点
  [104.139362,30.657813], // 中间点
  [104.13951,30.657375], // 中间点
  [104.140569,30.657748], // 中间点
  [104.142295,30.658086], // 中间点
  [104.143377,30.658141], // 中间点
  [104.143944,30.658031], // 中间点
  [104.151238,30.655803], // 中间点
  [104.157935,30.652755], // 中间点
  [104.158263,30.65244], // 中间点
  [104.158925,30.652226], // 中间点
  [104.162953,30.664067], // 中间点
  [104.162953,30.669465], // 中间点
  [104.162113,30.682281], // 中间点
  [104.1573,30.682112], // 中间点
  [104.156326,30.682285], // 中间点
  [104.149977,30.68556], // 中间点
  [104.147199,30.687332], // 中间点
  [104.144804,30.689197], // 中间点
  [104.139568,30.693353], // 中间点
  [104.126428,30.680765] // 终点
];

// 绘制(十里店的重点区域)
var shili3Km = [
  [104.102131,30.685749], // 起点
  [104.107967,30.693238], // 中间点
  [104.108057,30.69428], // 中间点
  [104.105723,30.697944], // 中间点
  [104.116857,30.697864], // 中间点
  [104.129645,30.700161], // 中间点
  [104.135299,30.701592], // 中间点
  [104.139278,30.703411], // 中间点
  [104.144714,30.705039], // 中间点
  [104.14792,30.708768], // 中间点
  [104.150423,30.708373], // 中间点
  [104.152825,30.707392], // 中间点
  [104.155065,30.706132], // 中间点
  [104.157195,30.704418], // 中间点
  [104.15885,30.702607], // 中间点
  [104.160675,30.698492], // 中间点
  [104.16664,30.699497], // 中间点
  [104.171804,30.699254], // 中间点
  [104.188195,30.700055], // 中间点
  [104.187197,30.694207], // 中间点
  [104.186839,30.689627], // 中间点
  [104.186578,30.687126], // 中间点
  [104.182343,30.683659], // 中间点
  [104.180795,30.683133], // 中间点
  [104.172854,30.682818], // 中间点
  [104.165525,30.682433], // 中间点
  [104.165613,30.680501], // 中间点
  [104.167486,30.675703], // 中间点
  [104.169428,30.675638], // 中间点
  [104.170787,30.673633], // 中间点
  [104.171675,30.673729], // 中间点
  [104.173647,30.671462], // 中间点
  [104.175302,30.671714], // 中间点
  [104.176836,30.668996], // 中间点
  [104.177752,30.668582], // 中间点
  [104.177835,30.667793], // 中间点
  [104.17719,30.666379], // 中间点
  [104.177253,30.662172], // 中间点
  [104.177376,30.646481], // 中间点
  [104.172127,30.645988], // 中间点
  [104.169183,30.645809], // 中间点
  [104.157546,30.64858], // 中间点
  [104.154428,30.648818], // 中间点
  [104.148887,30.65013], // 中间点
  [104.145388,30.649579], // 中间点
  [104.141406,30.649449], // 中间点
  [104.135214,30.647763], // 中间点
  [104.131852,30.647248], // 中间点
  [104.127988,30.647931], // 中间点
  [104.124479,30.650231], // 中间点
  [104.122466,30.650793], // 中间点
  [104.117716,30.650854], // 中间点
  [104.114725,30.65089], // 中间点
  [104.114901,30.658828], // 中间点
  [104.111888,30.666814], // 中间点
  [104.108394,30.675467], // 中间点
  [104.105752,30.680198], // 中间点
  [104.102851,30.685162], // 中间点
  [104.102131,30.685749] // 终点
];

// 绘制(金博路的核心区域)
var jinbo1Km = [
  [103.993676,30.678853], // 起点
  [104.000179,30.689398], // 中间点
  [104.003321,30.697741], // 中间点
  [104.005813,30.700292], // 中间点
  [104.010096,30.702992], // 中间点
  [104.016938,30.705128], // 中间点
  [104.020725,30.706983], // 中间点
  [104.022802,30.703412], // 中间点
  [104.025652,30.699245], // 中间点
  [104.028169,30.697226], // 中间点
  [104.030021,30.695859], // 中间点
  [104.027395,30.694503], // 中间点
  [104.02539,30.692911], // 中间点
  [104.022708,30.690629], // 中间点
  [104.020326,30.688548], // 中间点
  [104.019514,30.687602], // 中间点
  [104.017812,30.684689], // 中间点
  [104.015017,30.680721], // 中间点
  [104.011858,30.676502], // 中间点
  [104.01027,30.67468], // 中间点
  [104.009614,30.672209], // 中间点
  [104.006892,30.672751], // 中间点
  [104.000266,30.675845], // 中间点
  [103.993676,30.678853] // 终点
];

// 绘制(金博路的重点区域)
var jinbo3Km = [
  [103.976167,30.668941], // 起点
  [103.975562,30.673842], // 中间点
  [103.975343,30.683162], // 中间点
  [103.975355,30.685684], // 中间点
  [103.978999,30.692506], // 中间点
  [103.982922,30.699438], // 中间点
  [103.987371,30.703845], // 中间点
  [103.988984,30.70537], // 中间点
  [103.991002,30.707803], // 中间点
  [103.992296,30.709467], // 中间点
  [103.994647,30.71181], // 中间点
  [103.997856,30.715413], // 中间点
  [104.000916,30.718543], // 中间点
  [104.001525,30.719127], // 中间点
  [104.004709,30.720547], // 中间点
  [104.006027,30.721311], // 中间点
  [104.008185,30.723032], // 中间点
  [104.009299,30.723462], // 中间点
  [104.012039,30.72482], // 中间点
  [104.01461,30.726175], // 中间点
  [104.016807,30.727432], // 中间点
  [104.021735,30.730919], // 中间点
  [104.023438,30.728533], // 中间点
  [104.029698,30.720793], // 中间点
  [104.033964,30.715266], // 中间点
  [104.038511,30.709457], // 中间点
  [104.042323,30.704593], // 中间点
  [104.046546,30.699176], // 中间点
  [104.048557,30.696171], // 中间点
  [104.049804,30.694412], // 中间点西南交大地铁
  [104.046452,30.694132], // 中间点
  [104.044152,30.693395], // 中间点
  [104.04009,30.690297], // 中间点
  [104.032034,30.683416], // 中间点
  [104.025437,30.67769], // 中间点
  [104.022606,30.67508], // 中间点
  [104.021457,30.672911], // 中间点
  [104.021457,30.670235], // 中间点
  [104.021659,30.662387], // 中间点
  [104.018774,30.662311], // 中间点
  [104.015838,30.662588], // 中间点
  [104.012344,30.664596], // 中间点
  [104.011547,30.664792], // 中间点
  [104.010255,30.664805], // 中间点
  [104.008096,30.66512], // 中间点
  [104.005415,30.665644], // 中间点
  [104.003323,30.665631], // 中间点
  [104.000237,30.665576], // 中间点
  [103.997821,30.666666], // 中间点
  [103.996549,30.667407], // 中间点
  [103.993992,30.667786], // 中间点
  [103.9913,30.668151], // 中间点
  [103.987674,30.668182], // 中间点
  [103.984325,30.668374], // 中间点
  [103.981543,30.668876], // 中间点
  [103.976167,30.668941] // 终点
];

// 绘制(金泉两河核心区域)
var jinquanlianghe1Km = [
  [103.956179,30.72473], // 起点
  [103.959892,30.72897], // 中间点
  [103.962938,30.73247], // 中间点
  [103.964808,30.73464], // 中间点
  [103.967252,30.73646], // 中间点
  [103.970814,30.739334], // 中间点
  [103.97162,30.7402], // 中间点
  [103.974347,30.743697], // 中间点
  [103.976178,30.74586], // 中间点
  [103.97443,30.743589], // 中间点
  [103.973943,30.74275], // 中间点
  [103.973543,30.741098], // 中间点
  [103.974114,30.739119], // 中间点
  [103.974816,30.737861], // 中间点
  [103.976134,30.73649], // 中间点
  [103.978011,30.734666], // 中间点
  [103.980086,30.732179], // 中间点
  [103.982007,30.729973], // 中间点
  [103.984354,30.727353], // 中间点
  [103.988672,30.723339], // 中间点
  [103.98935,30.722798], // 中间点
  [103.990427,30.722044], // 中间点
  [103.991426,30.721578], // 中间点
  [103.992501,30.721347], // 中间点
  [103.99457,30.721353], // 中间点
  [103.995289,30.721369], // 中间点
  [103.996157,30.721642], // 中间点
  [103.990627,30.719957], // 中间点
  [103.991197,30.718285], // 中间点
  [103.98883,30.71521], // 中间点
  [103.987217,30.713225], // 中间点
  [103.986544,30.712448], // 中间点
  [103.985095,30.711401], // 中间点
  [103.983299,30.710607], // 中间点
  [103.981564,30.70983], // 中间点
  [103.977328,30.707776], // 中间点
  [103.974085,30.706238], // 中间点
  [103.97347,30.708973], // 中间点
  [103.972704,30.710483], // 中间点
  [103.971502,30.711856], // 中间点
  [103.968788,30.713831], // 中间点
  [103.967468,30.714824], // 中间点
  [103.963641,30.718333], // 中间点
  [103.961843,30.719968], // 中间点
  [103.959914,30.72137], // 中间点
  [103.958365,30.722724], // 中间点
  [103.956179,30.72473] // 终点
];

// 绘制(金泉两河的重点区域)
var jinquanlianghe3Km = [
  [103.91844,30.694674], // 起点
  [103.916811,30.700084], // 中间点
  [103.913609,30.709604], // 中间点
  [103.912235,30.713891], // 中间点
  [103.910318,30.71804], // 中间点
  [103.909037,30.720693], // 中间点
  [103.906462,30.725971], // 中间点
  [103.908133,30.726554], // 中间点
  [103.909932,30.727212], // 中间点
  [103.910119,30.727373], // 中间点
  [103.911544,30.729095], // 中间点
  [103.912802,30.730556], // 中间点
  [103.914259,30.732172], // 中间点
  [103.916588,30.734928], // 中间点
  [103.916866,30.735644], // 中间点
  [103.916866,30.736598], // 中间点
  [103.915478,30.740979], // 中间点
  [103.915499,30.742473], // 中间点
  [103.915827,30.743274], // 中间点
  [103.91659,30.744379], // 中间点
  [103.918348,30.74642], // 中间点
  [103.921786,30.750194], // 中间点
  [103.924742,30.75354], // 中间点
  [103.928802,30.758154], // 中间点
  [103.932857,30.762662], // 中间点
  [103.936519,30.766822], // 中间点
  [103.942151,30.773174], // 中间点
  [103.947098,30.769848], // 中间点
  [103.94854,30.769258], // 中间点
  [103.950074,30.769057], // 中间点
  [103.950486,30.769029], // 中间点
  [103.953399,30.768886], // 中间点
  [103.954983,30.768419], // 中间点
  [103.957374,30.767198], // 中间点
  [103.96411,30.773413], // 中间点
  [103.966839,30.775282], // 中间点
  [103.969934,30.776891], // 中间点
  [103.973061,30.777773], // 中间点
  [103.978708,30.778639], // 中间点
  [103.987885,30.779794], // 中间点
  [103.989096,30.778695], // 中间点
  [103.990003,30.77773], // 中间点
  [103.990022,30.777548], // 中间点
  [103.990256,30.777331], // 中间点
  [103.990661,30.776979], // 中间点
  [103.990913,30.77657], // 中间点
  [103.991012,30.776215], // 中间点
  [103.991182,30.77474], // 中间点
  [103.991807,30.772891], // 中间点
  [103.993035,30.771801], // 中间点
  [103.99425,30.769548], // 中间点
  [103.99588,30.765158], // 中间点
  [103.998205,30.758644], // 中间点
  [103.99866,30.755583], // 中间点
  [103.999061,30.753302], // 中间点
  [104.00062,30.751099], // 中间点
  [104.003997,30.74768], // 中间点
  [104.009675,30.743194], // 中间点
  [104.014467,30.739274], // 中间点
  [104.017888,30.734487], // 中间点
  [104.018566,30.733594], // 中间点
  [104.021525,30.730844], // 中间点
  [104.019805,30.72958], // 中间点
  [104.016817,30.727425], // 中间点
  [104.01457,30.726131], // 中间点
  [104.009326,30.723388], // 中间点
  [104.008354,30.723137], // 中间点
  [104.005962,30.721256], // 中间点
  [104.003115,30.719828], // 中间点
  [104.000848,30.718576], // 中间点
  [103.999238,30.716871], // 中间点
  [103.996609,30.714205], // 中间点
  [103.994647,30.711803], // 中间点
  [103.993044,30.710345], // 中间点
  [103.992195,30.709449], // 中间点
  [103.990935,30.707861], // 中间点
  [103.988973,30.70541], // 中间点
  [103.987625,30.704031], // 中间点
  [103.985874,30.702417], // 中间点
  [103.983246,30.699951], // 中间点
  [103.982274,30.698792], // 中间点
  [103.980214,30.694717], // 中间点
  [103.978474,30.691454], // 中间点
  [103.976768,30.688553], // 中间点
  [103.975523,30.686207], // 中间点
  [103.975282,30.685439], // 中间点
  [103.97526,30.68317], // 中间点
  [103.975409,30.678313], // 中间点
  [103.975493,30.673965], // 中间点
  [103.965411,30.676804], // 中间点
  [103.960551,30.678225], // 中间点
  [103.954079,30.680318], // 中间点
  [103.952061,30.681319], // 中间点
  [103.946771,30.684549], // 中间点
  [103.94259,30.686672], // 中间点
  [103.939795,30.687381], // 中间点
  [103.93794,30.688221], // 中间点
  [103.931974,30.691729], // 中间点
  [103.926582,30.693744], // 中间点
  [103.923582,30.694131], // 中间点
  [103.920374,30.69453], // 中间点
  [103.91844,30.694674] // 终点
];

// 绘制(车城东七路和龙泉驿区政府核心区域)
var longquan1Km = [
  [104.277489,30.573594], // 起点
  [104.283063,30.565287], // 中间点
  [104.286554,30.559765], // 中间点
  [104.279377,30.555119], // 中间点
  [104.277025,30.553825], // 中间点
  [104.276178,30.552852], // 中间点
  [104.271281,30.546425], // 中间点
  [104.270059,30.543159], // 中间点
  [104.269076,30.542059], // 中间点
  [104.26762,30.541284], // 中间点
  [104.266206,30.540883], // 中间点
  [104.264512,30.539878], // 中间点
  [104.263913,30.539266], // 中间点
  [104.262476,30.537198], // 中间点
  [104.261961,30.536841], // 中间点
  [104.260197,30.536431], // 中间点
  [104.258561,30.536076], // 中间点
  [104.257634,30.535713], // 中间点
  [104.255884,30.534841], // 中间点
  [104.253991,30.534556], // 中间点
  [104.253421,30.534417], // 中间点
  [104.251142,30.530149], // 中间点
  [104.250183,30.5268], // 中间点
  [104.248592,30.522971], // 中间点
  [104.243597,30.518254], // 中间点
  [104.243423,30.51712], // 中间点
  [104.242479,30.517025], // 中间点
  [104.239594,30.514706], // 中间点
  [104.237069,30.51277], // 中间点
  [104.233587,30.515354], // 中间点
  [104.231815,30.516661], // 中间点
  [104.228989,30.518082], // 中间点
  [104.227148,30.519117], // 中间点
  [104.226403,30.519873], // 中间点
  [104.225624,30.520911], // 中间点
  [104.228968,30.523578], // 中间点
  [104.233002,30.5274], // 中间点
  [104.24068,30.534526], // 中间点
  [104.246261,30.539886], // 中间点
  [104.252471,30.545814], // 中间点
  [104.255838,30.552377], // 中间点
  [104.260362,30.561126], // 中间点
  [104.262819,30.566705], // 中间点
  [104.26735,30.568932], // 中间点
  [104.272046,30.571109], // 中间点
  [104.277489,30.573594] // 终点
];

// 绘制(金车城东七路和龙泉驿区政府的重点区域)
var longquan5Km = [
  [104.246959,30.604108], // 起点
  [104.254274,30.599733], // 中间点
  [104.259713,30.597984], // 中间点
  [104.267039,30.597488], // 中间点
  [104.279641,30.59566], // 中间点
  [104.285299,30.595207], // 中间点
  [104.295832,30.595515], // 中间点
  [104.299373,30.595322], // 中间点
  [104.308771,30.590555], // 中间点
  [104.307774,30.589138], // 中间点
  [104.305792,30.587633], // 中间点
  [104.305117,30.587021], // 中间点
  [104.304462,30.586306], // 中间点
  [104.302999,30.585399], // 中间点
  [104.30279,30.585032], // 中间点
  [104.302163,30.584406], // 中间点
  [104.301004,30.583442], // 中间点
  [104.2994,30.582384], // 中间点
  [104.298967,30.582052], // 中间点
  [104.298758,30.581603], // 中间点
  [104.298729,30.580988], // 中间点
  [104.298815,30.580211], // 中间点
  [104.298694,30.579903], // 中间点
  [104.297617,30.578218], // 中间点
  [104.296935,30.577181], // 中间点
  [104.295507,30.575919], // 中间点
  [104.295227,30.575623], // 中间点
  [104.294556,30.574339], // 中间点
  [104.294007,30.573253], // 中间点
  [104.293462,30.572285], // 中间点
  [104.292987,30.571467], // 中间点
  [104.292675,30.571242], // 中间点
  [104.291545,30.570756], // 中间点
  [104.290677,30.570559], // 中间点
  [104.28986,30.570438], // 中间点
  [104.289187,30.570154], // 中间点
  [104.288411,30.569704], // 中间点
  [104.287691,30.56913], // 中间点
  [104.28692,30.568405], // 中间点
  [104.285941,30.567413], // 中间点
  [104.285498,30.566999], // 中间点
  [104.28433,30.566108], // 中间点
  [104.28303,30.565273], // 中间点
  [104.281676,30.564382], // 中间点
  [104.280929,30.561147], // 中间点
  [104.281486,30.559326], // 中间点
  [104.281946,30.557709], // 中间点
  [104.281946,30.557294], // 中间点
  [104.281683,30.556636], // 中间点
  [104.279377,30.555119], // 中间点
  [104.277025,30.553825], // 中间点
  [104.276178,30.552852], // 中间点
  [104.271281,30.546425], // 中间点
  [104.270289,30.543773], // 中间点
  [104.27156,30.543339], // 中间点
  [104.272414,30.543057], // 中间点
  [104.272875,30.542841], // 中间点
  [104.273451,30.542611], // 中间点
  [104.273934,30.542525], // 中间点
  [104.274394,30.542288], // 中间点
  [104.274721,30.541916], // 中间点
  [104.275738,30.54171], // 中间点
  [104.276371,30.541418], // 中间点
  [104.277001,30.540966], // 中间点
  [104.277908,30.540205], // 中间点
  [104.278181,30.539898], // 中间点
  [104.279629,30.536745], // 中间点
  [104.280072,30.535595], // 中间点
  [104.279904,30.535022], // 中间点
  [104.279951,30.534734], // 中间点
  [104.280357,30.534196], // 中间点
  [104.279701,30.533552], // 中间点
  [104.279701,30.53344], // 中间点
  [104.280235,30.532777], // 中间点
  [104.280661,30.532428], // 中间点
  [104.281114,30.532198], // 中间点
  [104.281668,30.532026], // 中间点
  [104.281755,30.531802], // 中间点
  [104.281705,30.531486], // 中间点
  [104.281531,30.530954], // 中间点
  [104.281663,30.530763], // 中间点
  [104.282294,30.530388], // 中间点
  [104.283243,30.530018], // 中间点
  [104.283741,30.529654], // 中间点
  [104.28375,30.529299], // 中间点
  [104.284018,30.529094], // 中间点
  [104.284415,30.52883], // 中间点
  [104.284652,30.528591], // 中间点
  [104.284792,30.528355], // 中间点
  [104.284884,30.52774], // 中间点
  [104.284852,30.527551], // 中间点
  [104.284624,30.527051], // 中间点
  [104.284254,30.525911], // 中间点
  [104.284322,30.525837], // 中间点
  [104.284699,30.525705], // 中间点
  [104.284407,30.524565], // 中间点
  [104.284401,30.523908], // 中间点
  [104.28431,30.523653], // 中间点
  [104.283998,30.523211], // 中间点
  [104.283616,30.522109], // 中间点
  [104.283753,30.521357], // 中间点
  [104.284167,30.521051], // 中间点
  [104.284599,30.520554], // 中间点
  [104.285143,30.520172], // 中间点
  [104.285202,30.520031], // 中间点
  [104.285063,30.519807], // 中间点
  [104.285072,30.519361], // 中间点
  [104.284856,30.518941], // 中间点
  [104.284892,30.518953], // 中间点
  [104.284871,30.518515], // 中间点
  [104.284736,30.518042], // 中间点
  [104.284376,30.517422], // 中间点
  [104.284281,30.517015], // 中间点
  [104.283928,30.516636], // 中间点
  [104.283699,30.516279], // 中间点
  [104.283544,30.515739], // 中间点
  [104.283451,30.514905], // 中间点
  [104.283412,30.514491], // 中间点
  [104.282615,30.513506], // 中间点
  [104.282511,30.512809], // 中间点
  [104.282271,30.512437], // 中间点
  [104.28149,30.511832], // 中间点
  [104.280621,30.51159], // 中间点
  [104.279805,30.511046], // 中间点
  [104.279459,30.510559], // 中间点
  [104.278586,30.509767], // 中间点
  [104.277835,30.508772], // 中间点
  [104.277377,30.508412], // 中间点
  [104.277166,30.508135], // 中间点
  [104.277081,30.507551], // 中间点
  [104.276761,30.50716], // 中间点
  [104.276422,30.506901], // 中间点
  [104.275916,30.50586], // 中间点
  [104.275852,30.505547], // 中间点
  [104.274977,30.504833], // 中间点
  [104.274977,30.504527], // 中间点
  [104.274855,30.504114], // 中间点
  [104.275189,30.503682], // 中间点
  [104.275122,30.503452], // 中间点
  [104.27508,30.502933], // 中间点
  [104.275257,30.502243], // 中间点
  [104.274814,30.501347], // 中间点
  [104.27511,30.500969], // 中间点
  [104.2752,30.500603], // 中间点
  [104.276028,30.500501], // 中间点
  [104.276052,30.500325], // 中间点
  [104.275617,30.499651], // 中间点
  [104.276477,30.499368], // 中间点
  [104.276931,30.499343], // 中间点
  [104.277585,30.499003], // 中间点
  [104.278254,30.498915], // 中间点
  [104.278267,30.498759], // 中间点
  [104.277804,30.498426], // 中间点
  [104.277956,30.497411], // 中间点
  [104.27766,30.496846], // 中间点
  [104.277339,30.496957], // 中间点
  [104.276376,30.496791], // 中间点
  [104.27626,30.496337], // 中间点
  [104.275361,30.496248], // 中间点
  [104.275262,30.495589], // 中间点
  [104.275099,30.495128], // 中间点
  [104.275498,30.493723], // 中间点
  [104.275351,30.493409], // 中间点
  [104.27509,30.492554], // 中间点
  [104.275485,30.491958], // 中间点
  [104.275308,30.491553], // 中间点
  [104.274962,30.491371], // 中间点
  [104.274768,30.49119], // 中间点
  [104.274541,30.491212], // 中间点
  [104.274414,30.491509], // 中间点
  [104.273946,30.491891], // 中间点
  [104.273161,30.492834], // 中间点
  [104.272982,30.493123], // 中间点
  [104.272258,30.492983], // 中间点
  [104.272312,30.492592], // 中间点
  [104.271851,30.492035], // 中间点
  [104.271433,30.491273], // 中间点
  [104.271145,30.491255], // 中间点
  [104.270569,30.49141], // 中间点
  [104.270256,30.490872], // 中间点
  [104.270523,30.48996], // 中间点
  [104.272192,30.489007], // 中间点
  [104.272463,30.488343], // 中间点
  [104.272338,30.487967], // 中间点
  [104.272083,30.487755], // 中间点
  [104.271924,30.487563], // 中间点
  [104.271365,30.487446], // 中间点
  [104.271395,30.487251], // 中间点
  [104.271709,30.487201], // 中间点
  [104.272031,30.48705], // 中间点
  [104.272623,30.487422], // 中间点
  [104.273402,30.487866], // 中间点
  [104.273653,30.488158], // 中间点
  [104.273895,30.487878], // 中间点
  [104.273789,30.487707], // 中间点
  [104.273443,30.487552], // 中间点
  [104.273366,30.48715], // 中间点
  [104.273147,30.486913], // 中间点
  [104.273033,30.48657], // 中间点
  [104.272541,30.486109], // 中间点
  [104.271633,30.485533], // 中间点
  [104.271103,30.48454], // 中间点
  [104.270638,30.483733], // 中间点
  [104.270553,30.483459], // 中间点
  [104.270266,30.48279], // 中间点
  [104.269905,30.482769], // 中间点
  [104.270061,30.484261], // 中间点
  [104.269499,30.483764], // 中间点
  [104.269221,30.483008], // 中间点
  [104.26635,30.483586], // 中间点
  [104.26635,30.483586], // 中间点
  [104.266026,30.482343], // 中间点
  [104.264006,30.481535], // 中间点
  [104.264727,30.479315], // 中间点
  [104.265122,30.477701], // 中间点
  [104.263639,30.477954], // 中间点
  [104.262712,30.477421], // 中间点
  [104.262628,30.476695], // 中间点
  [104.26155,30.476972], // 中间点
  [104.261296,30.476505], // 中间点
  [104.259616,30.477005], // 中间点
  [104.258011,30.477095], // 中间点
  [104.257936,30.475371], // 中间点
  [104.258041,30.474013], // 中间点
  [104.257535,30.47359], // 中间点
  [104.256608,30.47359], // 中间点
  [104.256347,30.473282], // 中间点
  [104.255139,30.473307], // 中间点
  [104.254618,30.473107], // 中间点
  [104.253787,30.472941], // 中间点
  [104.253984,30.471602], // 中间点
  [104.253591,30.471263], // 中间点
  [104.25325,30.471144], // 中间点
  [104.253208,30.470735], // 中间点
  [104.252684,30.470331], // 中间点
  [104.252173,30.469965], // 中间点
  [104.251932,30.470084], // 中间点
  [104.250888,30.469706], // 中间点
  [104.238193,30.474977], // 中间点
  [104.225487,30.480133], // 中间点
  [104.21212,30.48661], // 中间点
  [104.202937,30.492665], // 中间点
  [104.198936,30.495828], // 中间点
  [104.196133,30.498314], // 中间点
  [104.189473,30.504654], // 中间点
  [104.185366,30.508639], // 中间点
  [104.172891,30.521194], // 中间点
  [104.177478,30.525799], // 中间点
  [104.18369,30.531617], // 中间点
  [104.19042,30.538149], // 中间点
  [104.196026,30.54358], // 中间点
  [104.199564,30.548858], // 中间点
  [104.202095,30.552829], // 中间点
  [104.20521,30.558283], // 中间点
  [104.211269,30.569643], // 中间点
  [104.212904,30.572641], // 中间点
  [104.213875,30.575842], // 中间点
  [104.218198,30.585542], // 中间点
  [104.219924,30.587922], // 中间点
  [104.221713,30.589733], // 中间点
  [104.224363,30.591809], // 中间点
  [104.227805,30.593713], // 中间点
  [104.232281,30.595206], // 中间点
  [104.237749,30.597061], // 中间点
  [104.241014,30.59862], // 中间点
  [104.244171,30.601375], // 中间点
  [104.246959,30.604108], // 终点
];

// 绘制(科学城核心区域)
var kexuecheng1Km = [
  [104.072441,30.386226], // 起点
  [104.07236,30.393281], // 中间点
  [104.072311,30.397004], // 中间点
  [104.072283,30.402174], // 中间点
  [104.072265,30.406913], // 中间点
  [104.072253,30.413896], // 中间点
  [104.074404,30.414186], // 中间点
  [104.077765,30.414765], // 中间点
  [104.080892,30.415374], // 中间点
  [104.083244,30.416099], // 中间点
  [104.084899,30.416969], // 中间点
  [104.086881,30.418204], // 中间点
  [104.08874,30.42062], // 中间点
  [104.090044,30.422917], // 中间点
  [104.092319,30.4272], // 中间点
  [104.093484,30.429114], // 中间点
  [104.094788,30.430262], // 中间点
  [104.09755,30.4336], // 中间点
  [104.10045,30.43691], // 中间点
  [104.102135,30.434119], // 中间点
  [104.103565,30.431673], // 中间点
  [104.104179,30.430251], // 中间点
  [104.104454,30.427933], // 中间点
  [104.104403,30.424476], // 中间点
  [104.104235,30.420364], // 中间点
  [104.10413,30.417858], // 中间点
  [104.103984,30.415059], // 中间点
  [104.104068,30.412319], // 中间点
  [104.104339,30.408949], // 中间点
  [104.104769,30.404385], // 中间点
  [104.105276,30.398928], // 中间点
  [104.105619,30.394857], // 中间点
  [104.105542,30.391956], // 中间点
  [104.105032,30.389249], // 中间点
  [104.104001,30.386226], // 中间点
  [104.102808,30.383557], // 中间点
  [104.101699,30.381168], // 中间点
  [104.09257,30.382749], // 中间点
  [104.084385,30.383978], // 中间点
  [104.079091,30.384922], // 中间点
  [104.072441,30.386226] // 终点
];

// 绘制(科学城重点区域)
var kexuecheng3Km = [
  [103.965455,30.383883], // 起点
  [103.966632,30.388378], // 中间点
  [103.967674,30.392582], // 中间点
  [103.968602,30.395203], // 中间点
  [103.970058,30.397213], // 中间点
  [103.973839,30.401386], // 中间点
  [103.97841,30.406199], // 中间点
  [103.982076,30.410223], // 中间点
  [103.986717,30.415329], // 中间点
  [103.991258,30.420334], // 中间点
  [103.996413,30.4259], // 中间点
  [103.999501,30.429204], // 中间点
  [104.001845,30.431921], // 中间点
  [104.003188,30.433883], // 中间点
  [104.004448,30.435969], // 中间点
  [104.005839,30.437081], // 中间点
  [104.007635,30.438287], // 中间点
  [104.009802,30.440469], // 中间点
  [104.011471,30.442845], // 中间点
  [104.013225,30.445922], // 中间点
  [104.014478,30.448129], // 中间点
  [104.015354,30.449713], // 中间点
  [104.018177,30.448729], // 中间点
  [104.019758,30.448466], // 中间点
  [104.021802,30.44842], // 中间点
  [104.025503,30.44842], // 中间点
  [104.02928,30.448394], // 中间点
  [104.031838,30.448205], // 中间点
  [104.033707,30.447758], // 中间点
  [104.036467,30.447086], // 中间点
  [104.038061,30.446979], // 中间点
  [104.039837,30.447381], // 中间点
  [104.044544,30.449202], // 中间点
  [104.046453,30.449307], // 中间点
  [104.048939,30.448579], // 中间点
  [104.050532,30.447468], // 中间点
  [104.053783,30.443801], // 中间点
  [104.055097,30.442909], // 中间点
  [104.05686,30.442331], // 中间点
  [104.059135,30.442229], // 中间点
  [104.062538,30.442432], // 中间点
  [104.064363,30.443149], // 中间点
  [104.066579,30.443919], // 中间点
  [104.072311,30.444695], // 中间点
  [104.075994,30.444982], // 中间点
  [104.080744,30.444537], // 中间点
  [104.082636,30.444653], // 中间点
  [104.085571,30.445178], // 中间点
  [104.090065,30.444677], // 中间点
  [104.095892,30.444091], // 中间点
  [104.100921,30.443725], // 中间点
  [104.106102,30.443438], // 中间点
  [104.114348,30.442941], // 中间点
  [104.121478,30.442534], // 中间点
  [104.121403,30.443386], // 中间点
  [104.121638,30.439677], // 中间点
  [104.124025,30.434924], // 中间点
  [104.1256,30.431002], // 中间点
  [104.125959,30.42551], // 中间点
  [104.12698,30.422033], // 中间点
  [104.128493,30.41854], // 中间点
  [104.129672,30.414392], // 中间点
  [104.12955,30.407614], // 中间点
  [104.129428,30.401778], // 中间点
  [104.128937,30.399861], // 中间点
  [104.126857,30.395769], // 中间点
  [104.124156,30.39062], // 中间点
  [104.120763,30.384396], // 中间点
  [104.119875,30.381247], // 中间点
  [104.119382,30.378225], // 中间点
  [104.118499,30.373928], // 中间点
  [104.118647,30.368395], // 中间点
  [104.117188,30.359724], // 中间点
  [104.115017,30.352366], // 中间点
  [104.115063,30.350128], // 中间点
  [104.115562,30.34752], // 中间点
  [104.117031,30.344416], // 中间点
  [104.118924,30.340726], // 中间点
  [104.113383,30.340504], // 中间点
  [104.102535,30.340528], // 中间点
  [104.09417,30.340481], // 中间点
  [104.09034,30.340644], // 中间点
  [104.087538,30.34131], // 中间点
  [104.085004,30.342373], // 中间点
  [104.079268,30.346109], // 中间点
  [104.073429,30.349974], // 中间点
  [104.070304,30.35154], // 中间点
  [104.065364,30.352931], // 中间点
  [104.058143,30.35475], // 中间点
  [104.050368,30.358149], // 中间点
  [104.04049,30.363273], // 中间点
  [104.03625,30.365257], // 中间点
  [104.025616,30.368503], // 中间点
  [104.01485,30.371638], // 中间点
  [104.010272,30.372451], // 中间点
  [104.000955,30.373687], // 中间点
  [103.997675,30.374189], // 中间点
  [103.993118,30.375616], // 中间点
  [103.986829,30.378565], // 中间点
  [103.983829,30.379633], // 中间点
  [103.980938,30.380481], // 中间点
  [103.975953,30.381531], // 中间点
  [103.971371,30.382575], // 中间点
  [103.967907,30.383319], // 中间点
  [103.965455,30.383883] // 终点
];

// 绘制(华阳核心区域)
var huayang1Km = [
  [104.047692,30.511843], // 起点
  [104.047332,30.515477], // 中间点
  [104.047248,30.51605], // 中间点
  [104.046832,30.516768], // 中间点
  [104.046495,30.517527], // 中间点
  [104.046476,30.518392], // 中间点
  [104.046997,30.520756], // 中间点
  [104.047356,30.522482], // 中间点
  [104.04775,30.524546], // 中间点
  [104.048133,30.526232], // 中间点
  [104.052324,30.52658], // 中间点
  [104.05624,30.526879], // 中间点
  [104.059208,30.526862], // 中间点
  [104.062335,30.526917], // 中间点
  [104.066399,30.526912], // 中间点
  [104.0698,30.526941], // 中间点
  [104.06987,30.522936], // 中间点
  [104.069948,30.519994], // 中间点
  [104.068698,30.518607], // 中间点
  [104.065827,30.51642], // 中间点
  [104.064114,30.51507], // 中间点
  [104.062248,30.513578], // 中间点
  [104.061195,30.512528], // 中间点
  [104.059735,30.510944], // 中间点
  [104.05802,30.508869], // 中间点
  [104.056055,30.510015], // 中间点
  [104.053886,30.511292], // 中间点
  [104.052434,30.512105], // 中间点
  [104.051798,30.51212], // 中间点
  [104.050142,30.512027], // 中间点
  [104.047692,30.511843] // 终点
];

// 绘制(华阳的重点区域)
var huayang3Km = [
  [104.017748,30.553148], // 起点
  [104.019048,30.552707], // 中间点
  [104.021215,30.546599], // 中间点
  [104.073315,30.546866], // 中间点
  [104.07577,30.547707], // 中间点
  [104.077652,30.547789], // 中间点
  [104.080941,30.545819], // 中间点
  [104.088281,30.549144], // 中间点
  [104.090492,30.549632], // 中间点
  [104.093654,30.550148], // 中间点
  [104.096261,30.550174], // 中间点
  [104.098412,30.550163], // 中间点
  [104.102533,30.550219], // 中间点
  [104.105573,30.550219], // 中间点
  [104.108096,30.55017], // 中间点
  [104.108326,30.544514], // 中间点
  [104.109906,30.539853], // 中间点
  [104.110982,30.53678], // 中间点
  [104.11162,30.533942], // 中间点
  [104.111751,30.528937], // 中间点
  [104.111781,30.523372], // 中间点
  [104.112039,30.510834], // 中间点
  [104.112203,30.505121], // 中间点
  [104.113144,30.500768], // 中间点
  [104.114803,30.495855], // 中间点
  [104.115377,30.493455], // 中间点
  [104.115705,30.490171], // 中间点
  [104.11577,30.484506], // 中间点
  [104.115843,30.478687], // 中间点
  [104.107771,30.480604], // 中间点
  [104.098062,30.483105], // 中间点
  [104.092115,30.484597], // 中间点
  [104.081974,30.486198], // 中间点
  [104.076358,30.487005], // 中间点
  [104.070861,30.487617], // 中间点
  [104.067485,30.487279], // 中间点
  [104.063849,30.486442], // 中间点
  [104.057756,30.485271], // 中间点
  [104.056782,30.485244], // 中间点
  [104.04632,30.485408], // 中间点
  [104.032503,30.485566], // 中间点
  [104.025574,30.485671], // 中间点
  [104.018755,30.485375], // 中间点
  [104.01118,30.485135], // 中间点
  [104.008099,30.485075], // 中间点
  [104.005511,30.485371], // 中间点
  [104.002685,30.485857], // 中间点
  [103.99946,30.486521], // 中间点
  [103.996955,30.48712], // 中间点
  [103.993245,30.488719], // 中间点
  [103.995931,30.493072], // 中间点
  [103.998485,30.497193], // 中间点
  [104.002018,30.503201], // 中间点
  [104.00309,30.50495], // 中间点
  [104.003777,30.507081], // 中间点
  [104.005499,30.51266], // 中间点
  [104.006684,30.516808], // 中间点
  [104.007371,30.519036], // 中间点
  [104.002925,30.519995], // 中间点
  [104.001771,30.520393], // 中间点
  [104.001163,30.520673], // 中间点
  [103.997559,30.522622], // 中间点
  [103.994391,30.524313], // 中间点
  [103.99057,30.52644], // 中间点
  [103.995833,30.532015], // 中间点
  [103.999073,30.53524], // 中间点
  [104.000938,30.536786], // 中间点
  [104.005442,30.539536], // 中间点
  [104.008202,30.541453], // 中间点
  [104.011278,30.544247], // 中间点
  [104.013473,30.546546], // 中间点
  [104.015896,30.54988], // 中间点
  [104.017748,30.553148], // 终点
];

// 绘制(青白江技师分院核心区域)
var qingbaijiang1Km = [
  [104.382706,30.739281], // 起点
  [104.387415,30.740229], // 中间点
  [104.390331,30.741044], // 中间点
  [104.391704,30.741333], // 中间点
  [104.392254,30.742106], // 中间点
  [104.392558,30.74275], // 中间点
  [104.392997,30.743882], // 中间点
  [104.393141,30.744202], // 中间点
  [104.393298,30.745104], // 中间点
  [104.393548,30.746035], // 中间点
  [104.39381,30.747284], // 中间点
  [104.394086,30.748419], // 中间点
  [104.39426,30.748585], // 中间点
  [104.394937,30.748748], // 中间点
  [104.395312,30.748906], // 中间点
  [104.395198,30.749954], // 中间点
  [104.394996,30.751236], // 中间点
  [104.394789,30.753498], // 中间点
  [104.394641,30.75516], // 中间点
  [104.394334,30.756366], // 中间点
  [104.393288,30.755313], // 中间点
  [104.390726,30.753459], // 中间点
  [104.388344,30.751428], // 中间点
  [104.386573,30.749543], // 中间点
  [104.384672,30.747566], // 中间点
  [104.383722,30.746466], // 中间点
  [104.383254,30.745393], // 中间点
  [104.382941,30.742625], // 中间点
  [104.382706,30.739281] // 终点
];

// 绘制(青白江技师分院的重点区域)
var qingbaijiang3Km = [
  [104.439146,30.843173], // 起点
  [104.44107,30.841057], // 中间点
  [104.441842,30.839976], // 中间点
  [104.442246,30.839328], // 中间点
  [104.442829,30.838504], // 中间点
  [104.443403,30.837921], // 中间点
  [104.443701,30.837792], // 中间点
  [104.44457,30.837581], // 中间点
  [104.444748,30.837475], // 中间点
  [104.445088,30.836804], // 中间点
  [104.445839,30.835916], // 中间点
  [104.447045,30.834479], // 中间点
  [104.448037,30.833031], // 中间点
  [104.448382,30.832513], // 中间点
  [104.448614,30.831672], // 中间点
  [104.44873,30.830999], // 中间点
  [104.448564,30.830077], // 中间点
  [104.448603,30.829725], // 中间点
  [104.449107,30.82886], // 中间点
  [104.449553,30.828047], // 中间点
  [104.449719,30.827663], // 中间点
  [104.449758,30.827295], // 中间点
  [104.449508,30.826308], // 中间点
  [104.449208,30.824945], // 中间点
  [104.448897,30.8235], // 中间点
  [104.448761,30.822713], // 中间点
  [104.448716,30.822275], // 中间点
  [104.44866,30.820303], // 中间点
  [104.448589,30.818269], // 中间点
  [104.448554,30.81782], // 中间点
  [104.448342,30.817153], // 中间点
  [104.447512,30.815747], // 中间点
  [104.446587,30.814122], // 中间点
  [104.445875,30.812797], // 中间点
  [104.445779,30.812387], // 中间点
  [104.445805,30.81162], // 中间点
  [104.446198,30.809976], // 中间点
  [104.446784,30.807637], // 中间点
  [104.447634,30.804159], // 中间点
  [104.447535,30.80372], // 中间点
  [104.447094,30.801925], // 中间点
  [104.449204,30.80086], // 中间点
  [104.450346,30.800321], // 中间点
  [104.450575,30.800293], // 中间点
  [104.451448,30.800262], // 中间点
  [104.453882,30.800102], // 中间点
  [104.454138,30.799985], // 中间点
  [104.454577,30.799581], // 中间点
  [104.45509,30.799004], // 中间点
  [104.455365,30.798757], // 中间点
  [104.45607,30.798434], // 中间点
  [104.457478,30.798078], // 中间点
  [104.458071,30.797938], // 中间点
  [104.45865,30.797717], // 中间点
  [104.45931,30.79736], // 中间点
  [104.461464,30.795916], // 中间点
  [104.462054,30.79551], // 中间点
  [104.462392,30.795334], // 中间点
  [104.463244,30.795103], // 中间点
  [104.463941,30.794925], // 中间点
  [104.464211,30.794906], // 中间点
  [104.466389,30.794761], // 中间点
  [104.468318,30.794649], // 中间点
  [104.46973,30.794432], // 中间点
  [104.469976,30.794379], // 中间点
  [104.470861,30.79426], // 中间点
  [104.471898,30.794206], // 中间点
  [104.473019,30.794187], // 中间点
  [104.473651,30.794353], // 中间点
  [104.47471,30.794676], // 中间点
  [104.476137,30.794887], // 中间点
  [104.478103,30.795018], // 中间点
  [104.481009,30.794315], // 中间点
  [104.483013,30.793719], // 中间点
  [104.483434,30.79351], // 中间点
  [104.484567,30.792846], // 中间点
  [104.485843,30.792142], // 中间点
  [104.486034,30.791904], // 中间点
  [104.486214,30.791511], // 中间点
  [104.48671,30.789752], // 中间点
  [104.48711,30.78773], // 中间点
  [104.487294,30.786769], // 中间点
  [104.48768,30.786291], // 中间点
  [104.488322,30.785558], // 中间点
  [104.488717,30.785086], // 中间点
  [104.489153,30.784237], // 中间点
  [104.489472,30.783471], // 中间点
  [104.489856,30.782672], // 中间点
  [104.490268,30.782101], // 中间点
  [104.49161,30.780358], // 中间点
  [104.492866,30.778699], // 中间点
  [104.493157,30.778266], // 中间点
  [104.494074,30.776698], // 中间点
  [104.495167,30.775178], // 中间点
  [104.495868,30.774502], // 中间点
  [104.496548,30.773747], // 中间点
  [104.497373,30.772529], // 中间点
  [104.498168,30.771193], // 中间点
  [104.499322,30.768784], // 中间点
  [104.500161,30.767267], // 中间点
  [104.500776,30.766555], // 中间点
  [104.501459,30.765835], // 中间点
  [104.501607,30.765569], // 中间点
  [104.502476,30.76388], // 中间点
  [104.503355,30.762382], // 中间点
  [104.504075,30.761272], // 中间点
  [104.504663,30.760166], // 中间点
  [104.505402,30.758943], // 中间点
  [104.505817,30.758152], // 中间点
  [104.506114,30.757092], // 中间点
  [104.50616,30.756073], // 中间点
  [104.505989,30.754571], // 中间点
  [104.505812,30.754043], // 中间点
  [104.504536,30.751685], // 中间点
  [104.503114,30.750164], // 中间点
  [104.501182,30.748205], // 中间点
  [104.500479,30.74719], // 中间点
  [104.500029,30.7461], // 中间点
  [104.499687,30.744882], // 中间点
  [104.499533,30.743755], // 中间点
  [104.499568,30.742354], // 中间点
  [104.499888,30.741025], // 中间点
  [104.500396,30.739633], // 中间点
  [104.500645,30.737479], // 中间点
  [104.501079,30.734235], // 中间点
  [104.501511,30.732584], // 中间点
  [104.502127,30.731344], // 中间点
  [104.502622,30.730501], // 中间点
  [104.503556,30.729698], // 中间点
  [104.504005,30.729261], // 中间点
  [104.505708,30.727489], // 中间点
  [104.506467,30.726858], // 中间点
  [104.50719,30.726467], // 中间点
  [104.508193,30.726075], // 中间点
  [104.509046,30.725912], // 中间点
  [104.512002,30.725879], // 中间点
  [104.516464,30.725933], // 中间点
  [104.517581,30.726022], // 中间点
  [104.520343,30.72633], // 中间点
  [104.524008,30.726426], // 中间点
  [104.527014,30.726247], // 中间点
  [104.527554,30.726419], // 中间点
  [104.52855,30.72656], // 中间点
  [104.529734,30.726661], // 中间点
  [104.530133,30.726566], // 中间点
  [104.532125,30.725889], // 中间点
  [104.533014,30.725515], // 中间点
  [104.533337,30.72514], // 中间点
  [104.534071,30.723806], // 中间点
  [104.534701,30.723], // 中间点
  [104.535299,30.722444], // 中间点
  [104.535885,30.722326], // 中间点
  [104.536948,30.722172], // 中间点
  [104.538451,30.722091], // 中间点
  [104.539949,30.722125], // 中间点
  [104.540663,30.721964], // 中间点
  [104.543296,30.72134], // 中间点
  [104.546171,30.720639], // 中间点
  [104.545421,30.715431], // 中间点
  [104.54481,30.711311], // 中间点
  [104.544432,30.710488], // 中间点
  [104.54355,30.708992], // 中间点
  [104.536772,30.703263], // 中间点
  [104.534366,30.705342], // 中间点
  [104.532888,30.705022], // 中间点
  [104.529986,30.70482], // 中间点
  [104.528968,30.704275], // 中间点
  [104.528581,30.704265], // 中间点
  [104.52775,30.704476], // 中间点
  [104.527044,30.704321], // 中间点
  [104.525479,30.704154], // 中间点
  [104.524848,30.703997], // 中间点
  [104.524058,30.703843], // 中间点
  [104.523758,30.703606], // 中间点
  [104.523387,30.703124], // 中间点
  [104.522877,30.701481], // 中间点
  [104.523023,30.70098], // 中间点
  [104.522805,30.699669], // 中间点
  [104.522231,30.698805], // 中间点
  [104.519616,30.69732], // 中间点
  [104.517983,30.696494], // 中间点
  [104.517423,30.695863], // 中间点
  [104.51692,30.694941], // 中间点
  [104.516679,30.694866], // 中间点
  [104.515607,30.694713], // 中间点
  [104.514921,30.69424], // 中间点
  [104.514283,30.693043], // 中间点
  [104.514042,30.692844], // 中间点
  [104.513193,30.692293], // 中间点
  [104.512043,30.691357], // 中间点
  [104.510876,30.690093], // 中间点
  [104.509814,30.689142], // 中间点
  [104.508866,30.688508], // 中间点
  [104.508245,30.688008], // 中间点
  [104.506357,30.686062], // 中间点
  [104.503905,30.6841], // 中间点
  [104.503827,30.683698], // 中间点
  [104.504639,30.682691], // 中间点
  [104.504608,30.682275], // 中间点
  [104.503877,30.681099], // 中间点
  [104.503707,30.680108], // 中间点
  [104.501533,30.678663], // 中间点
  [104.501235,30.678316], // 中间点
  [104.501365,30.677154], // 中间点
  [104.500993,30.676358], // 中间点
  [104.500684,30.675489], // 中间点
  [104.500213,30.673105], // 中间点
  [104.500319,30.672743], // 中间点
  [104.501015,30.672001], // 中间点
  [104.501352,30.671333], // 中间点
  [104.501694,30.6708], // 中间点
  [104.501568,30.669692], // 中间点
  [104.500814,30.6683], // 中间点
  [104.500178,30.667753], // 中间点
  [104.500385,30.667037], // 中间点
  [104.500314,30.666955], // 中间点
  [104.499672,30.666652], // 中间点
  [104.499406,30.6666], // 中间点
  [104.498231,30.6659], // 中间点
  [104.497874,30.665478], // 中间点
  [104.497381,30.665079], // 中间点
  [104.4972,30.665048], // 中间点
  [104.495589,30.665735], // 中间点
  [104.494096,30.666176], // 中间点
  [104.49255,30.666118], // 中间点
  [104.490433,30.66539], // 中间点
  [104.489514,30.664466], // 中间点
  [104.489175,30.663882], // 中间点
  [104.48866,30.663702], // 中间点
  [104.486244,30.663749], // 中间点
  [104.486244,30.664181], // 中间点
  [104.486064,30.664356], // 中间点
  [104.485526,30.664498], // 中间点
  [104.482886,30.664531], // 中间点
  [104.482435,30.664624], // 中间点
  [104.482022,30.664807], // 中间点
  [104.480338,30.665139], // 中间点
  [104.479551,30.665101], // 中间点
  [104.478415,30.665276], // 中间点
  [104.477129,30.666751], // 中间点
  [104.475357,30.66813], // 中间点
  [104.474832,30.668404], // 中间点
  [104.474375,30.668578], // 中间点
  [104.473799,30.669203], // 中间点
  [104.473008,30.66987], // 中间点
  [104.471655,30.670311], // 中间点
  [104.471156,30.670789], // 中间点
  [104.470917,30.67161], // 中间点
  [104.469858,30.673633], // 中间点
  [104.469788,30.674078], // 中间点
  [104.469694,30.675336], // 中间点
  [104.469535,30.675424], // 中间点
  [104.468955,30.675405], // 中间点
  [104.468868,30.67604], // 中间点
  [104.468571,30.676994], // 中间点
  [104.468434,30.677661], // 中间点
  [104.467864,30.678347], // 中间点
  [104.466539,30.680272], // 中间点
  [104.466373,30.680993], // 中间点
  [104.466197,30.681159], // 中间点
  [104.46598,30.681193], // 中间点
  [104.46557,30.681049], // 中间点
  [104.464535,30.680961], // 中间点
  [104.463479,30.681168], // 中间点
  [104.462655,30.681689], // 中间点
  [104.46249,30.682054], // 中间点
  [104.46252,30.682663], // 中间点
  [104.462406,30.682778], // 中间点
  [104.461858,30.682758], // 中间点
  [104.461259,30.683024], // 中间点
  [104.46135,30.683299], // 中间点
  [104.461495,30.683347], // 中间点
  [104.46264,30.683836], // 中间点
  [104.463458,30.685145], // 中间点
  [104.46361,30.686372], // 中间点
  [104.463165,30.686619], // 中间点
  [104.462358,30.686495], // 中间点
  [104.461658,30.686624], // 中间点
  [104.460833,30.687054], // 中间点
  [104.460166,30.687681], // 中间点
  [104.459882,30.688439], // 中间点
  [104.459372,30.689232], // 中间点
  [104.45901,30.689713], // 中间点
  [104.45797,30.690512], // 中间点
  [104.457523,30.690817], // 中间点
  [104.456457,30.691843], // 中间点
  [104.455839,30.692364], // 中间点
  [104.454884,30.693131], // 中间点
  [104.454871,30.693324], // 中间点
  [104.455118,30.693631], // 中间点
  [104.455098,30.693773], // 中间点
  [104.454513,30.694276], // 中间点
  [104.45264,30.695499], // 中间点
  [104.451093,30.696533], // 中间点
  [104.450776,30.696919], // 中间点
  [104.45025,30.697267], // 中间点
  [104.447591,30.698388], // 中间点
  [104.444999,30.699537], // 中间点
  [104.442559,30.700866], // 中间点
  [104.441316,30.700969], // 中间点
  [104.440407,30.700615], // 中间点
  [104.43973,30.699813], // 中间点
  [104.438703,30.699553], // 中间点
  [104.438166,30.699622], // 中间点
  [104.437366,30.699762], // 中间点
  [104.436937,30.699653], // 中间点
  [104.436428,30.699291], // 中间点
  [104.436262,30.698979], // 中间点
  [104.436413,30.697854], // 中间点
  [104.436376,30.697591], // 中间点
  [104.436096,30.697015], // 中间点
  [104.43595,30.696943], // 中间点
  [104.435343,30.697051], // 中间点
  [104.434671,30.696944], // 中间点
  [104.433461,30.696592], // 中间点
  [104.433012,30.696424], // 中间点
  [104.432671,30.696575], // 中间点
  [104.43228,30.697179], // 中间点
  [104.432292,30.697753], // 中间点
  [104.432058,30.698165], // 中间点
  [104.43126,30.698811], // 中间点
  [104.430516,30.699071], // 中间点
  [104.429381,30.699162], // 中间点
  [104.428837,30.699649], // 中间点
  [104.428005,30.69985], // 中间点
  [104.427538,30.700066], // 中间点
  [104.426964,30.699995], // 中间点
  [104.426187,30.699908], // 中间点
  [104.425361,30.699892], // 中间点
  [104.424758,30.699744], // 中间点
  [104.424095,30.699406], // 中间点
  [104.422126,30.698685], // 中间点
  [104.421207,30.698392], // 中间点
  [104.41939,30.69741], // 中间点
  [104.418774,30.697364], // 中间点
  [104.418122,30.697436], // 中间点
  [104.416187,30.69797], // 中间点
  [104.414318,30.698481], // 中间点
  [104.413738,30.698481], // 中间点
  [104.413322,30.698278], // 中间点
  [104.412243,30.697505], // 中间点
  [104.41167,30.696789], // 中间点
  [104.411286,30.696808], // 中间点
  [104.410649,30.697561], // 中间点
  [104.410366,30.698172], // 中间点
  [104.409356,30.699394], // 中间点
  [104.409213,30.699917], // 中间点
  [104.409269,30.700283], // 中间点
  [104.40912,30.70044], // 中间点
  [104.408869,30.700477], // 中间点
  [104.408873,30.699683], // 中间点
  [104.407612,30.699432], // 中间点
  [104.407086,30.699103], // 中间点
  [104.406585,30.698889], // 中间点
  [104.406303,30.698656], // 中间点
  [104.405289,30.696812], // 中间点
  [104.404845,30.696463], // 中间点
  [104.404257,30.696332], // 中间点
  [104.403658,30.696389], // 中间点
  [104.402947,30.696197], // 中间点
  [104.402182,30.695574], // 中间点
  [104.401292,30.695386], // 中间点
  [104.401025,30.695203], // 中间点
  [104.400038,30.694244], // 中间点
  [104.399493,30.693918], // 中间点
  [104.398618,30.693656], // 中间点
  [104.397611,30.692801], // 中间点
  [104.39728,30.692283], // 中间点
  [104.397108,30.692249], // 中间点
  [104.396285,30.693122], // 中间点
  [104.39552,30.693774], // 中间点
  [104.395145,30.693904], // 中间点
  [104.394894,30.693513], // 中间点
  [104.394324,30.693507], // 中间点
  [104.393321,30.693309], // 中间点
  [104.392597,30.692892], // 中间点
  [104.391921,30.692369], // 中间点
  [104.391284,30.69224], // 中间点
  [104.390765,30.692217], // 中间点
  [104.390283,30.691575], // 中间点
  [104.390299,30.689914], // 中间点
  [104.390093,30.689283], // 中间点
  [104.389719,30.688995], // 中间点
  [104.389264,30.688795], // 中间点
  [104.388313,30.688805], // 中间点
  [104.387798,30.688668], // 中间点
  [104.387668,30.688437], // 中间点
  [104.387727,30.687613], // 中间点
  [104.387629,30.687275], // 中间点
  [104.387234,30.686714], // 中间点
  [104.386852,30.686352], // 中间点
  [104.386413,30.685654], // 中间点
  [104.386021,30.685188], // 中间点
  [104.385573,30.68454], // 中间点
  [104.384716,30.684301], // 中间点
  [104.383838,30.684103], // 中间点
  [104.383184,30.683928], // 中间点
  [104.382624,30.683878], // 中间点
  [104.382412,30.683355], // 中间点
  [104.382071,30.68286], // 中间点
  [104.381475,30.682487], // 中间点
  [104.379163,30.680519], // 中间点
  [104.379069,30.680085], // 中间点
  [104.379682,30.679508], // 中间点
  [104.379835,30.678756], // 中间点
  [104.379577,30.677757], // 中间点
  [104.379422,30.677546], // 中间点
  [104.379063,30.677083], // 中间点
  [104.378991,30.675892], // 中间点
  [104.378835,30.675638], // 中间点
  [104.37818,30.674963], // 中间点
  [104.377242,30.67418], // 中间点
  [104.376086,30.674704], // 中间点
  [104.37482,30.675227], // 中间点
  [104.372543,30.675122], // 中间点
  [104.370925,30.675045], // 中间点
  [104.370608,30.674875], // 中间点
  [104.370425,30.674636], // 中间点
  [104.370534,30.674284], // 中间点
  [104.369421,30.673692], // 中间点
  [104.368019,30.672767], // 中间点
  [104.367921,30.672656], // 中间点
  [104.367624,30.672236], // 中间点
  [104.367473,30.672095], // 中间点
  [104.367068,30.671961], // 中间点
  [104.366101,30.671907], // 中间点
  [104.365211,30.671915], // 中间点
  [104.364806,30.672018], // 中间点
  [104.364267,30.672224], // 中间点
  [104.364008,30.672142], // 中间点
  [104.363767,30.671836], // 中间点
  [104.36374,30.670787], // 中间点
  [104.363512,30.670251], // 中间点
  [104.363031,30.669827], // 中间点
  [104.362228,30.669375], // 中间点
  [104.361442,30.668851], // 中间点
  [104.360989,30.668784], // 中间点
  [104.360649,30.668826], // 中间点
  [104.360338,30.668718], // 中间点
  [104.3593,30.668007], // 中间点
  [104.358301,30.667197], // 中间点
  [104.357903,30.667004], // 中间点
  [104.357642,30.666979], // 中间点
  [104.356298,30.667005], // 中间点
  [104.354237,30.667619], // 中间点
  [104.353663,30.6677], // 中间点
  [104.352783,30.667628], // 中间点
  [104.352175,30.667882], // 中间点
  [104.352128,30.668199], // 中间点
  [104.352114,30.668405], // 中间点
  [104.351916,30.668403], // 中间点
  [104.351323,30.667965], // 中间点
  [104.351089,30.66795], // 中间点
  [104.350619,30.668047], // 中间点
  [104.349761,30.667886], // 中间点
  [104.349559,30.667777], // 中间点
  [104.349149,30.667345], // 中间点
  [104.348738,30.666629], // 中间点
  [104.348538,30.666591], // 中间点
  [104.347352,30.667568], // 中间点
  [104.347107,30.667946], // 中间点
  [104.346929,30.668677], // 中间点
  [104.346784,30.668865], // 中间点
  [104.345949,30.668979], // 中间点
  [104.344645,30.6692], // 中间点
  [104.342316,30.668541], // 中间点
  [104.341535,30.668481], // 中间点
  [104.338981,30.668262], // 中间点
  [104.340398,30.672142], // 中间点
  [104.34105,30.673301], // 中间点
  [104.342499,30.67535], // 中间点
  [104.342633,30.676034], // 中间点
  [104.342584,30.676702], // 中间点
  [104.342416,30.677749], // 中间点
  [104.342468,30.67981], // 中间点
  [104.34251,30.681694], // 中间点
  [104.342531,30.68299], // 中间点
  [104.342414,30.684885], // 中间点
  [104.342497,30.685312], // 中间点
  [104.342982,30.68632], // 中间点
  [104.343579,30.688676], // 中间点
  [104.344203,30.68955], // 中间点
  [104.34493,30.690644], // 中间点
  [104.346004,30.692546], // 中间点
  [104.346031,30.692869], // 中间点
  [104.345296,30.693998], // 中间点
  [104.343878,30.695784], // 中间点
  [104.342573,30.697356], // 中间点
  [104.341742,30.698461], // 中间点
  [104.341445,30.698985], // 中间点
  [104.338996,30.701411], // 中间点
  [104.337552,30.702935], // 中间点
  [104.336218,30.704346], // 中间点
  [104.335101,30.705477], // 中间点
  [104.33433,30.705944], // 中间点
  [104.333957,30.70619], // 中间点
  [104.333461,30.70674], // 中间点
  [104.333078,30.707291], // 中间点
  [104.332636,30.708208], // 中间点
  [104.332394,30.709047], // 中间点
  [104.332389,30.709572], // 中间点
  [104.332487,30.710137], // 中间点
  [104.33276,30.7105], // 中间点
  [104.330403,30.711868], // 中间点
  [104.326789,30.714161], // 中间点
  [104.324252,30.715794], // 中间点
  [104.321425,30.717211], // 中间点
  [104.320254,30.717468], // 中间点
  [104.318972,30.717826], // 中间点
  [104.314595,30.718215], // 中间点
  [104.309047,30.718637], // 中间点
  [104.303013,30.719106], // 中间点
  [104.296207,30.719707], // 中间点
  [104.285112,30.720641], // 中间点
  [104.2759,30.723854], // 中间点
  [104.274244,30.724005], // 中间点
  [104.272968,30.723981], // 中间点
  [104.28002,30.725512], // 中间点
  [104.291562,30.728995], // 中间点
  [104.298859,30.731093], // 中间点
  [104.299053,30.730495], // 中间点
  [104.297694,30.733474], // 中间点
  [104.298035,30.735506], // 中间点
  [104.29896,30.736198], // 中间点
  [104.299374,30.736705], // 中间点
  [104.299347,30.737331], // 中间点
  [104.297996,30.738734], // 中间点
  [104.296552,30.740639], // 中间点
  [104.295883,30.741416], // 中间点
  [104.295297,30.742006], // 中间点
  [104.294411,30.743136], // 中间点
  [104.294167,30.74375], // 中间点
  [104.294176,30.746418], // 中间点
  [104.293736,30.748048], // 中间点
  [104.292696,30.749089], // 中间点
  [104.292368,30.749582], // 中间点
  [104.292063,30.750627], // 中间点
  [104.290899,30.75296], // 中间点
  [104.290184,30.753846], // 中间点
  [104.288677,30.755501], // 中间点
  [104.28843,30.755949], // 中间点
  [104.287706,30.757616], // 中间点
  [104.287448,30.758678], // 中间点
  [104.287245,30.76077], // 中间点
  [104.28715,30.761097], // 中间点
  [104.286968,30.761374], // 中间点
  [104.286457,30.763379], // 中间点
  [104.286299,30.763962], // 中间点
  [104.285912,30.764754], // 中间点
  [104.285729,30.765277], // 中间点
  [104.285712,30.765803], // 中间点
  [104.285722,30.766744], // 中间点
  [104.285673,30.767588], // 中间点
  [104.28557,30.768104], // 中间点
  [104.285594,30.768608], // 中间点
  [104.28625,30.770267], // 中间点
  [104.286284,30.770516], // 中间点
  [104.286193,30.770805], // 中间点
  [104.286025,30.771236], // 中间点
  [104.286022,30.771658], // 中间点
  [104.285467,30.771948], // 中间点
  [104.285088,30.77231], // 中间点
  [104.28506,30.773446], // 中间点
  [104.28506,30.77432], // 中间点
  [104.285164,30.775166], // 中间点
  [104.286127,30.777351], // 中间点
  [104.286365,30.7779], // 中间点
  [104.286811,30.779783], // 中间点
  [104.286932,30.780195], // 中间点
  [104.287188,30.78066], // 中间点
  [104.288241,30.781935], // 中间点
  [104.288431,30.782387], // 中间点
  [104.288308,30.783935], // 中间点
  [104.288344,30.784561], // 中间点
  [104.288673,30.786915], // 中间点
  [104.288778,30.78795], // 中间点
  [104.28867,30.78879], // 中间点
  [104.288119,30.790458], // 中间点
  [104.287984,30.791271], // 中间点
  [104.287704,30.791893], // 中间点
  [104.288546,30.793808], // 中间点
  [104.288546,30.793808], // 中间点
  [104.290551,30.797028], // 中间点
  [104.291393,30.797163], // 中间点
  [104.292851,30.797486], // 中间点
  [104.294384,30.797941], // 中间点
  [104.294773,30.798254], // 中间点
  [104.295934,30.798938], // 中间点
  [104.298157,30.79998], // 中间点
  [104.299234,30.800643], // 中间点
  [104.299622,30.800757], // 中间点
  [104.300437,30.800822], // 中间点
  [104.301098,30.801], // 中间点
  [104.302538,30.802269], // 中间点
  [104.304884,30.803201], // 中间点
  [104.307499,30.804131], // 中间点
  [104.309984,30.804748], // 中间点
  [104.311321,30.805042], // 中间点
  [104.314409,30.805479], // 中间点
  [104.315842,30.805755], // 中间点
  [104.317143,30.80604], // 中间点
  [104.318646,30.806406], // 中间点
  [104.321131,30.806635], // 中间点
  [104.32318,30.807071], // 中间点
  [104.32432,30.807101], // 中间点
  [104.328009,30.807041], // 中间点
  [104.330193,30.807074], // 中间点
  [104.332751,30.807221], // 中间点
  [104.335958,30.807462], // 中间点
  [104.336877,30.807672], // 中间点
  [104.337843,30.808069], // 中间点
  [104.338485,30.808534], // 中间点
  [104.339387,30.809439], // 中间点
  [104.341199,30.811384], // 中间点
  [104.343117,30.813223], // 中间点
  [104.343984,30.813862], // 中间点
  [104.344902,30.814384], // 中间点
  [104.345945,30.814841], // 中间点
  [104.347331,30.815307], // 中间点
  [104.348636,30.815564], // 中间点
  [104.350143,30.815809], // 中间点
  [104.35162,30.816066], // 中间点
  [104.353035,30.816329], // 中间点
  [104.354342,30.816822], // 中间点
  [104.355469,30.817605], // 中间点
  [104.356013,30.818164], // 中间点
  [104.356349,30.818681], // 中间点
  [104.356635,30.819242], // 中间点
  [104.356951,30.820141], // 中间点
  [104.357475,30.821298], // 中间点
  [104.357887,30.824314], // 中间点
  [104.357843,30.824682], // 中间点
  [104.357875,30.825412], // 中间点
  [104.357503,30.826106], // 中间点
  [104.35712,30.826392], // 中间点
  [104.356437,30.827154], // 中间点
  [104.356454,30.827134], // 中间点
  [104.355509,30.828013], // 中间点
  [104.354576,30.828857], // 中间点
  [104.354334,30.829149], // 中间点
  [104.354225,30.829171], // 中间点
  [104.35464,30.83057], // 中间点
  [104.355049,30.831558], // 中间点
  [104.355692,30.832819], // 中间点
  [104.356046,30.833123], // 中间点
  [104.357191,30.833847], // 中间点
  [104.359527,30.834846], // 中间点
  [104.363782,30.836425], // 中间点
  [104.369041,30.83827], // 中间点
  [104.37338,30.839762], // 中间点
  [104.373424,30.840307], // 中间点
  [104.380489,30.841335], // 中间点
  [104.387321,30.842334], // 中间点
  [104.39181,30.843135], // 中间点
  [104.39516,30.843209], // 中间点
  [104.40065,30.843212], // 中间点
  [104.40475,30.84348], // 中间点
  [104.409338,30.843731], // 中间点
  [104.416811,30.844158], // 中间点
  [104.416832,30.844131], // 中间点
  [104.421653,30.844129], // 中间点
  [104.425071,30.843922], // 中间点
  [104.428935,30.843715], // 中间点
  [104.43239,30.843556], // 中间点
  [104.434002,30.843443], // 中间点
  [104.439146,30.843173], // 终点
];

// 绘制(光华大道三段核心区域)
var guanghua1Km = [
  [103.83585,30.693995], // 起点
  [103.836649,30.694361], // 中间点
  [103.840114,30.694372], // 中间点
  [103.844635,30.694394], // 中间点
  [103.843305,30.697998], // 中间点
  [103.842908,30.699201], // 中间点
  [103.842643,30.699493], // 中间点
  [103.845195,30.700192], // 中间点
  [103.846651,30.700533], // 中间点
  [103.847729,30.700663], // 中间点
  [103.848357,30.700696], // 中间点
  [103.85057,30.700065], // 中间点
  [103.853928,30.699139], // 中间点
  [103.856398,30.698455], // 中间点
  [103.858083,30.698012], // 中间点
  [103.86003,30.697203], // 中间点
  [103.861901,30.69635], // 中间点
  [103.866027,30.694582], // 中间点
  [103.868139,30.693654], // 中间点
  [103.869298,30.693111], // 中间点
  [103.87029,30.692712], // 中间点
  [103.868963,30.691051], // 中间点
  [103.867714,30.689489], // 中间点
  [103.866464,30.687905], // 中间点
  [103.865254,30.686399], // 中间点
  [103.864382,30.685149], // 中间点
  [103.86325,30.683507], // 中间点
  [103.862043,30.681878], // 中间点
  [103.860961,30.680518], // 中间点
  [103.859041,30.681801],  // 中间点
  [103.857878,30.680472],  // 终点
  [103.855985,30.6784],  // 终点
  [103.854787,30.679585],  // 终点
  [103.853646,30.678544],  // 终点
  [103.85185,30.676976],  // 终点
  [103.849984,30.679234],  // 终点
  [103.848314,30.681327],  // 终点
  [103.846051,30.684163],  // 终点
  [103.845058,30.685444],  // 终点
  [103.844069,30.686687],  // 终点
  [103.843048,30.687958],  // 终点
  [103.842219,30.689044],  // 终点
  [103.840755,30.690793],  // 终点
  [103.838803,30.692077],  // 终点
  [103.83585,30.693995],  // 终点
];

// 绘制(光华大道三段的重点区域)
var guanghua3Km = [
  [103.822735,30.647424], // 起点
  [103.821383,30.650736], // 中间点
  [103.819391,30.655385], // 中间点
  [103.812129,30.652216], // 中间点
  [103.81001,30.656717], // 中间点
  [103.808054,30.660369], // 中间点
  [103.805906,30.664121], // 中间点
  [103.803561,30.668393], // 中间点
  [103.801458,30.672097], // 中间点
  [103.799744,30.675219], // 中间点
  [103.799003,30.676022], // 中间点
  [103.795698,30.679278], // 中间点
  [103.792724,30.6824], // 中间点
  [103.791505,30.685114], // 中间点
  [103.790643,30.686884], // 中间点
  [103.794089,30.689679], // 中间点
  [103.791576,30.694617], // 中间点
  [103.790367,30.696999], // 中间点
  [103.789285,30.699235], // 中间点
  [103.787787,30.702223], // 中间点
  [103.78656,30.704623], // 中间点
  [103.785045,30.707632], // 中间点
  [103.783871,30.709877], // 中间点
  [103.78141,30.714561], // 中间点
  [103.779217,30.7187], // 中间点
  [103.777053,30.722675], // 中间点
  [103.775326,30.725752], // 中间点
  [103.778401,30.72789], // 中间点
  [103.782171,30.730349], // 中间点
  [103.786206,30.733049], // 中间点
  [103.790701,30.735713], // 中间点
  [103.787668,30.738976], // 中间点
  [103.789489,30.74024], // 中间点
  [103.79091,30.74124], // 中间点
  [103.79261,30.742374], // 中间点
  [103.794718,30.74326], // 中间点
  [103.797084,30.744283], // 中间点
  [103.799222,30.745269], // 中间点
  [103.800923,30.745944], // 中间点
  [103.801534,30.745357], // 中间点
  [103.802745,30.744693], // 中间点
  [103.805579,30.743575], // 中间点
  [103.806904,30.74272], // 中间点
  [103.807511,30.74198], // 中间点
  [103.808102,30.740035], // 中间点
  [103.809233,30.740267], // 中间点
  [103.810533,30.740514], // 中间点
  [103.811664,30.740819], // 中间点
  [103.813188,30.741323], // 中间点
  [103.814909,30.741956], // 中间点
  [103.815985,30.742268], // 中间点
  [103.816992,30.742178], // 中间点
  [103.818616,30.742011], // 中间点
  [103.820059,30.741905], // 中间点
  [103.820699,30.741916], // 中间点
  [103.822582,30.741948], // 中间点
  [103.825291,30.742048], // 中间点
  [103.827493,30.742159], // 中间点
  [103.829055,30.742137], // 中间点
  [103.829498,30.742103], // 中间点
  [103.83064,30.741917], // 中间点
  [103.834771,30.741358], // 中间点
  [103.838336,30.740884], // 中间点
  [103.838033,30.739238], // 中间点
  [103.837944,30.738484], // 中间点
  [103.838003,30.73768], // 中间点
  [103.838236,30.736815], // 中间点
  [103.838649,30.735926], // 中间点
  [103.839122,30.73502], // 中间点
  [103.839467,30.734385], // 中间点
  [103.842552,30.735229], // 中间点
  [103.845148,30.735944], // 中间点
  [103.846459,30.736334], // 中间点
  [103.848148,30.736984], // 中间点
  [103.851627,30.738024], // 中间点
  [103.854181,30.734451], // 中间点
  [103.856172,30.731482], // 中间点
  [103.85784,30.729138], // 中间点
  [103.860437,30.725693], // 中间点
  [103.863739,30.730807], // 中间点
  [103.86672,30.735336], // 中间点
  [103.871739,30.744579], // 中间点
  [103.876405,30.740937], // 中间点
  [103.879403,30.738619], // 中间点
  [103.883328,30.735562], // 中间点
  [103.887667,30.732184], // 中间点
  [103.890209,30.730177], // 中间点
  [103.892528,30.728302], // 中间点
  [103.89592,30.725839], // 中间点
  [103.899035,30.72652], // 中间点
  [103.901774,30.72724], // 中间点
  [103.903657,30.727664], // 中间点
  [103.905529,30.728093], // 中间点
  [103.906462,30.725971], // 中间点
  [103.909037,30.720693], // 中间点
  [103.910318,30.71804], // 中间点
  [103.912235,30.713891], // 中间点
  [103.913609,30.709604], // 中间点
  [103.916811,30.700084], // 中间点
  [103.91844,30.694674], // 中间点
  [103.91923,30.692708], // 中间点
  [103.91957,30.692188], // 中间点
  [103.921712,30.690032], // 中间点
  [103.921626,30.687935], // 中间点
  [103.919027,30.683939], // 中间点
  [103.914526,30.677148], // 中间点
  [103.911656,30.678015], // 中间点
  [103.909365,30.678172], // 中间点
  [103.908303,30.677996], // 中间点
  [103.903041,30.677095], // 中间点
  [103.901491,30.676976], // 中间点
  [103.89818,30.67697], // 中间点
  [103.893857,30.677091], // 中间点
  [103.895241,30.673315], // 中间点
  [103.896528,30.669867], // 中间点
  [103.895909,30.669793], // 中间点
  [103.892695,30.665874], // 中间点
  [103.890427,30.663286], // 中间点
  [103.889836,30.662879], // 中间点
  [103.886987,30.661337], // 中间点
  [103.882311,30.658749], // 中间点
  [103.877811,30.65644], // 中间点
  [103.872668,30.653608], // 中间点
  [103.865969,30.649877], // 中间点
  [103.857386,30.64507], // 中间点
  [103.853575,30.651054], // 中间点
  [103.852798,30.650863], // 中间点
  [103.851096,30.65045], // 中间点
  [103.846756,30.649506], // 中间点
  [103.840402,30.648074], // 中间点
  [103.836462,30.646403], // 中间点
  [103.835741,30.646331], // 中间点
  [103.835011,30.646414], // 中间点
  [103.831181,30.646902], // 中间点
  [103.828961,30.647168], // 中间点
  [103.826753,30.647466], // 中间点
  [103.824979,30.647692], // 中间点
  [103.824011,30.647625], // 中间点
  [103.822735,30.647424], // 终点
];




export{
  sanwayao1Km,//三瓦窑的核心区域
  sanwayao3Km,//三瓦窑的重点区域
  shahepu1Km,//沙河铺的核心区域
  shahepu3Km,//沙河铺的重点区域
  dashi1Km,//大石西路和君平街的核心区域
  dashi3Km,//大石西路和君平街的重点区域
  shili1Km,//十里店核心区域
  shili3Km,//十里店的重点区域
  jinbo1Km,//金博路的核心区域
  jinbo3Km,//金博路的重点区域
  jinquanlianghe1Km,//金泉两河的核心区域
  jinquanlianghe3Km,//金泉两河的重点区域
  longquan1Km,//车城东七路和龙泉驿区政府核心区域
  longquan5Km,//金车城东七路和龙泉驿区政府的重点区域
  kexuecheng1Km,//科学城核心区域
  kexuecheng3Km,//科学城重点区域
  huayang1Km,//华阳核心区域
  huayang3Km,//华阳的重点区域
  qingbaijiang1Km,//青白江技师分院核心区域
  qingbaijiang3Km,//青白江技师分院的重点区域
  guanghua1Km,//光华大道三段核心区域
  guanghua3Km,//光华大道三段的重点区域
}
